import { Box, InnerBox } from '@/components/common/atoms';
import { Col, Row, Typography } from 'antd';

export const TableBoxContainer = ({ title, aside, table, children, rowProps }) => {
  return (
    <Box $padding={0}>
      <InnerBox $padding={1} $noBorder>
        <Row justify={'space-between'} {...rowProps}>
          <Typography.Text>{title}</Typography.Text>

          <Col>{aside}</Col>
        </Row>

        {children}
      </InnerBox>
      {table}
    </Box>
  );
};
